site.tables = site.tables || {};
site.tables = $.extend(site.tables, {
	responsive: function () {
		$('table.data.responsive').each(function() {
			var $this = $(this);
			var headertext = [];
			var headers = $("thead", $this);
			var tablebody = $("tbody", $this);

			for(var i = 0; i < headers.length; i++) {
				headertext[i]=[];
				for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
					var current = headrow;
					headertext[i].push(current.textContent.replace(/\r?\n|\r/,""));
				}
			}

			if (headers.length > 0) {
				for (var h = 0, tbody; tbody = tablebody[h]; h++) {
					for (var i = 0, row; row = tbody.rows[i]; i++) {
						for (var j = 0, col; col = row.cells[j]; j++) {
							col.setAttribute("data-th", headertext[h][j]);
						}
					}
				}
			}
		});
	}
});

site.inits.push('site.tables.responsive()');
